import { render, staticRenderFns } from "./asidpart.vue?vue&type=template&id=b1eb3022&scoped=true"
import script from "./asidpart.vue?vue&type=script&lang=js"
export * from "./asidpart.vue?vue&type=script&lang=js"
import style0 from "./asidpart.vue?vue&type=style&index=0&id=b1eb3022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eb3022",
  null
  
)

export default component.exports